var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWaitList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-waitList",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.199,
    height: 41.352,
    viewBox: "0 0 33.199 41.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2599",
    "data-name": "Ret\\xE2ngulo 2599",
    width: 33.199,
    height: 41.352,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5284",
    "data-name": "Grupo 5284",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2854",
    "data-name": "Caminho 2854",
    d: "M30.355,285.352a9.532,9.532,0,0,1-.137,1.656,3.108,3.108,0,0,1-2.949,2.767,10.876,10.876,0,0,1-1.325.086q-9.314.008-18.629,0a10.7,10.7,0,0,1-1.281-.081,3.223,3.223,0,0,1-3.068-3.161c-.032-.346-.053-.695-.062-1.043q-1.434-.017-2.868-.028c0,.252,0,.5,0,.756a6.182,6.182,0,0,0,3.577,5.781,6.632,6.632,0,0,0,3.177.65c6.506-.022,13.012-.016,19.519-.019.044,0,.088.006.133.009a6.381,6.381,0,0,0,6.788-6.44q0-.554,0-1.107-1.434.094-2.87.174",
    transform: "translate(-0.031 -251.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2855",
    "data-name": "Caminho 2855",
    d: "M2.867,29.2q-.006-8.98,0-17.961A10.179,10.179,0,0,1,2.961,9.69,3.247,3.247,0,0,1,6.279,6.678c.437-.034.88,0,1.3,0A12.124,12.124,0,0,0,7.9,7.923a3.875,3.875,0,0,0,3.754,2.511c3.252-.033,6.505-.044,9.757-.005a3.875,3.875,0,0,0,4.11-3.357c.021-.129.039-.258.063-.414a6.031,6.031,0,0,1,2.95.445,3.215,3.215,0,0,1,1.726,2.761,10.807,10.807,0,0,1,.071,1.327q.006,8.892,0,17.785,1.433-.081,2.866-.174-.015-3.563-.02-7.126,0-5.721.028-11.442a6.355,6.355,0,0,0-5.665-6.418A17.186,17.186,0,0,0,25.588,3.8c-.039-.228-.07-.415-.1-.6A3.83,3.83,0,0,0,21.645,0Q16.588.012,11.531,0A3.783,3.783,0,0,0,9.395.626a3.923,3.923,0,0,0-1.77,3.162c-.235,0-.426.016-.614,0A6.333,6.333,0,0,0,.19,8.674a12.393,12.393,0,0,0-.159,2.6C.011,17.237-.008,23.2,0,29.17q1.432.01,2.864.028M10.488,3.742a.812.812,0,0,1,.767-.835A5.79,5.79,0,0,1,12,2.852q4.591-.005,9.182,0c.148,0,.3,0,.443.008.768.052,1.075.342,1.094,1.1q.032,1.263,0,2.527c-.02.74-.329,1.058-1.07,1.066-1.685.019-3.371.006-5.057.006v.013q-2.24,0-4.48,0a6.471,6.471,0,0,1-.8-.033.821.821,0,0,1-.827-.829c-.036-.989-.032-1.98,0-2.969",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2597",
    "data-name": "Ret\\xE2ngulo 2597",
    width: 2.868,
    height: 7.74,
    transform: "translate(0.004 27.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2598",
    "data-name": "Ret\\xE2ngulo 2598",
    width: 2.868,
    height: 6.74,
    transform: "translate(30.331 27.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2856",
    "data-name": "Caminho 2856",
    d: "M52.121,118.921a.625.625,0,0,1,.625.625v1.844a.625.625,0,0,1-.625.625H50.055a.625.625,0,0,1-.625-.625v-1.844a.625.625,0,0,1,.625-.625Zm0-1.3H50.055a1.93,1.93,0,0,0-1.928,1.928v1.844a1.93,1.93,0,0,0,1.928,1.928h2.066a1.931,1.931,0,0,0,1.928-1.928v-1.844a1.93,1.93,0,0,0-1.928-1.928",
    transform: "translate(-42.424 -103.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2857",
    "data-name": "Caminho 2857",
    d: "M114.762,133.7h10.605a1.238,1.238,0,1,0,0-2.476H114.762a1.238,1.238,0,1,0,0,2.476",
    transform: "translate(-100.071 -115.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2858",
    "data-name": "Caminho 2858",
    d: "M52.121,176.921a.625.625,0,0,1,.625.625v1.844a.625.625,0,0,1-.625.625H50.055a.625.625,0,0,1-.625-.625v-1.844a.625.625,0,0,1,.625-.625Zm0-1.3H50.055a1.93,1.93,0,0,0-1.928,1.928v1.844a1.93,1.93,0,0,0,1.928,1.928h2.066a1.93,1.93,0,0,0,1.928-1.928v-1.844a1.93,1.93,0,0,0-1.928-1.928",
    transform: "translate(-42.424 -154.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2859",
    "data-name": "Caminho 2859",
    d: "M114.762,191.7h10.605a1.238,1.238,0,1,0,0-2.476H114.762a1.238,1.238,0,1,0,0,2.476",
    transform: "translate(-100.071 -166.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2860",
    "data-name": "Caminho 2860",
    d: "M52.121,237.346a.625.625,0,0,1,.625.625v1.844a.625.625,0,0,1-.625.625H50.055a.625.625,0,0,1-.625-.625v-1.844a.625.625,0,0,1,.625-.625Zm0-1.3H50.055a1.93,1.93,0,0,0-1.928,1.928v1.844a1.93,1.93,0,0,0,1.928,1.928h2.066a1.931,1.931,0,0,0,1.928-1.928v-1.844a1.93,1.93,0,0,0-1.928-1.928",
    transform: "translate(-42.424 -208.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2861",
    "data-name": "Caminho 2861",
    d: "M114.762,252.125h10.605a1.238,1.238,0,1,0,0-2.476H114.762a1.238,1.238,0,1,0,0,2.476",
    transform: "translate(-100.071 -220.066)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaitList);
export default __webpack_public_path__ + "static/media/icon-waitList.250bb4f95e97481d8589781297cbf59c.svg";
export { ForwardRef as ReactComponent };